import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RestrictedOtpRoute = ({ children }) => {
  const { resetEmail, forgotPasswordSuccess } = useAuth();

  if (!resetEmail && !forgotPasswordSuccess) {
    return <Navigate to="/forgot-password" replace />;
  }

  return children;
};

export default RestrictedOtpRoute;
